// Ordering for the "Recently Watched" sidebar list.
//
// Each watch_history entry records a precise `lastWatched` ISO timestamp on
// every play (see useSync). Older entries -- recorded before that field
// existed -- only have a day-level `dailyBreakdown`, so we fall back to the
// most recent day there.
//
// Using a precise per-video timestamp is what makes the list update correctly
// when several videos are watched on the same day: day-level dates all tie, so
// a newly watched video neither sorted above the others nor survived the
// top-N slice, and the sidebar appeared frozen / out of order (QA bug).
export const watchEntryRecency = (details) => {
  if (!details) return 0;

  if (details.lastWatched) {
    const t = new Date(details.lastWatched).getTime();
    if (Number.isFinite(t)) return t;
  }

  const days = Object.keys(details.dailyBreakdown || {});
  return days.reduce((max, d) => {
    const t = new Date(d).getTime();
    return Number.isFinite(t) && t > max ? t : max;
  }, 0);
};

// Build the ordered Recently Watched list from a watch_history map and the
// video catalogue. Returns at most `limit` entries, most-recently-watched
// first, each merged with its video metadata (title, url, ...). Entries whose
// video is no longer in the catalogue are dropped.
export const rankRecentlyWatched = (watchHistory, videos, limit = 5) => {
  if (!watchHistory) return [];

  return Object.entries(watchHistory)
    .map(([videoId, details]) => ({
      videoId,
      lastPosition: details?.lastPosition || 0,
      recency: watchEntryRecency(details),
    }))
    .sort((a, b) => b.recency - a.recency)
    .slice(0, limit)
    .map((entry) => ({
      ...entry,
      ...(videos || []).find((v) => String(v.id) === String(entry.videoId)),
    }))
    .filter((entry) => entry.id !== undefined);
};
